
<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Add/Update Language</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">
  

      <div class="form-group">
        <label>Name</label>

        <input type="text" formControlName="name" class="form-control">
      </div>
      <div class="form-group">
        <label>Code (tr-TR, en-EN,en-US vs)</label>

        <input type="text" formControlName="code" class="form-control" placeholder="tr">
      </div>
 
      <div class="form-group">
        <label>ApiCode</label>

        <input type="text" formControlName="apicode" class="form-control" placeholder="tur">
      </div>
 

      <div class="row mt-2">
        <div class="col-md-12">
          <h4>Icon <div *ngIf="data"><img src="{{data?.iconUrl}}"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="SelectSingleFile($event)">
            <ngx-dropzone-label>
                <div class="dz-default dz-message">
                    <span class = "dz-default">Drag and drop file or click to select<br/>File formats: png or jpg</span>
                </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview  ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="SinglefileonRemove(f)">
                <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
        </div>
       
       
      
      </div>
    </div>

     

    </div>

  


    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Close</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Save</button>
    </div>
  </form>
</div>

